import axios from 'axios';
import Cookies from 'js-cookie';
import { BASE_URL } from '../constants/Config';
import { UserLogout } from '../utils/UserLogout';
export const getApiRequest = async (endpoint, options = {}) => {
  const userData = Cookies.get('userDataProofreader');
  const token = userData ? JSON.parse(userData).Token : null;
  const sessionExpiredElement = document.getElementById('SessionExpired');

  const headers = {
    ...(token && { Authorization: `Bearer ${token}` }),
    'Content-Type': 'application/json',
    ...options.headers,
  };

  if (!Cookies.get('sessionExpireModalOpenProofreader') && !sessionExpiredElement) {
    try {
      const response = await axios.get(`${BASE_URL}${endpoint}`, {
        headers,
        ...options,
      });

      if (response.status === 401) {
        UserLogout();
      }

      return response;
    } catch (err) {
      if (err.response?.status === 401) {
        UserLogout();
      }
    }
  } else {
    UserLogout();
  }
};

export const postApiRequest = async (endpoint, action = {}, options = {}) => {
  const userData = Cookies.get('userDataProofreader');
  const token = userData ? JSON.parse(userData).Token : null;
  const sessionExpiredElement = document.getElementById('SessionExpired');

  const headers = {
    ...(token && { Authorization: `Bearer ${token}` }),
    'Content-Type': action instanceof FormData ? 'multipart/form-data' : 'application/json',
    ...options.headers,
  };

  if (!Cookies.get('sessionExpireModalOpenProofreader') && !sessionExpiredElement) {
    try {
      const response = await axios.post(`${BASE_URL}${endpoint}`, action, {
        headers,
        ...options,
      });

      if (response.status === 401) {
        UserLogout();
      }

      return response;
    } catch (err) {
      if (err.response?.status === 401) {
        UserLogout();
      }
    }
  } else {
    UserLogout();
  }
};

export const postBlobApiRequest = async (endpoint, data = {}, queryParams = {}, options = {}) => {
  const userData = Cookies.get('userDataProofreader');
  const token = userData ? JSON.parse(userData).Token : null;
  const sessionExpiredElement = document.getElementById('SessionExpired');

  const headers = {
    ...(token && { Authorization: `Bearer ${token}` }),
    'Content-Type': 'application/json',
    ...options.headers,
  };

  if (!Cookies.get('sessionExpireModalOpenProofreader') && !sessionExpiredElement) {
    try {
      const response = await axios.post(`${BASE_URL}${endpoint}`, data, {
        headers,
        params: queryParams,
        responseType: 'blob',
        ...options,
      });

      if (response.status === 401) {
        UserLogout();
      }

      return response;
    } catch (err) {
      if (err.response?.status === 401) {
        UserLogout();
      }
    }
  } else {
    UserLogout();
  }
};
